
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'position',
data () {
return {
show: false,
iframeSrc: ''
}
},
directives: {
TransferDom
},
props: {
visable: {
type: Boolean,
default: false
}
},
components: {
Popup
},
watch: {
visable (value) {
this.show = value
if (this.show) {
this.iframeSrc = 'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=6OOBZ-ASY6X-OYW4U-7PMGO-A2RLK-6EBQR&referer=myapp'
}
}
},
created () {
const self = this
window.addEventListener('message', function(event) {

let loc = event.data
if (loc && loc.module == 'locationPicker') { // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
self.$emit('location', loc)
}
}, false)
},
mounted () {
},
methods: {
onHide () {
this.$emit('on-hide')
}
}
}



// WEBPACK FOOTER //
// ./src/plugin/Position.vue